/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable sort-keys */
// https://chir.ag/projects/name-that-color/
export const colors = {
    persianRed: '#d32f2f',
    redWire: '#d65949',

    // oranges / yellows
    primary: '#ec9300',
    tangerine: '#ec9300',

    // greens
    apple: '#34b233',

    // teals / cyans
    pacificTeal: '#209b90',
    bondiBlue: '#00a5aa',
    secondary: '#00a5aa',
    cyanSky: '#00a5aa',
    darkTeal: '#004f52',
    teal: '#008085',
    fadedJade: '#447e83',

    // pale blues
    backgroundBlue: '#e7edef',
    mystic: '#e7edef',

    // blue-greens / blue-grays
    tePapaGreen: '#1e363e',
    plantation: '#264550',
    secondaryDark: '#264550',
    bigStoneTranslucent: 'rgba(25, 50, 67, 0.90)',

    // neutrals (dark → light)
    black: '#000000',
    blackTranslucent: 'rgba(0, 0, 0, 0.60)',
    mineShaft: '#242424',
    mineShaftTranslucent: 'rgba(36, 36, 36, 0.50)',
    shadowColor: 'rgba(36, 36, 36, 0.50)',
    tundora: '#4e4e4e',
    scorpion: '#5e5e5e',
    steelGray: '#404041',
    doveGray: '#707070',
    gray: '#919191',
    silver: '#c7c6c6',
    lightGray: '#e0e0e0',
    alto: '#e0e0e0',
    mercury: '#e5e5e5',
    gallery: '#f2f2f2',
    white: '#ffffff',
    whiteTranslucent: 'rgba(255, 255, 255, 0.60)',
    whiteTranslucentDark: 'rgba(255, 255, 255, 0.75)',
    whiteTranslucentLight: 'rgba(255, 255, 255, 0.45)'
} as const;

export type ScssColorKey = keyof typeof colors;
